import React from 'react';
import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';
import { HelpText } from '../helpTexts';
import { cardSx, launchColors, sectionTitleSx } from '../launchTheme';
import InfoTip from './InfoTip';

interface Props {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  info?: HelpText;
  children?: React.ReactNode;
  padded?: boolean;
  headingLevel?: 'h2' | 'h3';
  sx?: SxProps<Theme>;
}

const SectionCard: React.FC<Props> = ({ title, subtitle, action, info, children, padded = true, headingLevel = 'h2', sx }) => (
  <Box component="section" sx={[cardSx, { overflow: 'hidden' }, ...(Array.isArray(sx) ? sx : [sx])]}>
    {(title || action) && (
      <Stack direction="row" alignItems="center" spacing={1} useFlexGap flexWrap="wrap" sx={{ px: 2, pt: 1.75, pb: padded ? 0 : 1.25 }}>
        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
          {title && <Typography component={headingLevel} sx={sectionTitleSx}>{title}</Typography>}
          {info && <InfoTip text={info} />}
          {subtitle && <Typography component="span" sx={{ fontSize: 12, color: launchColors.textSecondary }}>{subtitle}</Typography>}
        </Box>
        {action}
      </Stack>
    )}
    <Box sx={padded ? { p: 2 } : undefined}>{children}</Box>
  </Box>
);

export default SectionCard;
